module.exports = __webpack_public_path__ + "static/media/infinite-blue.395f86a5.svg";